import { cn } from "@btnet/utilities-core";

import "./HighlightField.less";

interface IHighlightFieldProps {
    isActive?: boolean;
    children: React.ReactNode;
    color?: "highlight" | "warning";
}

export const HighlightField: React.FC<IHighlightFieldProps> = (props) => {
    const color = props.color ?? "highlight";
    return props.isActive ? (
        <div className={cn("HighlightField", color)}>{props.children}</div>
    ) : (
        <>{props.children}</>
    );
};

export const HighlightTab: React.FC<IHighlightFieldProps> = (props) => {
    return props.isActive ? (
        <div className="HighlightTab">{props.children}</div>
    ) : (
        <>{props.children}</>
    );
};
